export default "__VITE_ASSET__B2Ygm1yh__"